export function YandexKey() {
    const config = useRuntimeConfig()
    const yandexKeyCromiRent = import.meta.env.VITE_YANDEX_KEY_CROMI_RENT
    const yandexKeyCromiRu = import.meta.env.VITE_YANDEX_KEY_CROMI_RU
    const yandexKeyRadioguideRent = import.meta.env
        .VITE_YANDEX_KEY_RADIOGUIDE_RENT

    if (config.public.website == 'radioguide.rent')
        return yandexKeyRadioguideRent
    if (config.public.website == 'cromi.rent') return yandexKeyCromiRent
    if (config.public.website == 'cromi.ru') return yandexKeyCromiRu
    return ''
}
